import React from 'react';
import { Controller } from 'react-hook-form';
import { Box, FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import { AsyncSelect } from 'chakra-react-select';

const AsyncSelectController = ({
  name,
  label,
  control,
  styleContainer,
  styleBoxInput,
  isRequired,
  placeholder,
  options,
  loadOptions,
  onChange,
  onInputChange,
  handleOnScrollBottom,
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl {...styleContainer} isRequired={isRequired} isInvalid={error && error?.message}>
          {label && <FormLabel minW="150px">{label}</FormLabel>}
          <Box {...styleBoxInput}>
            <AsyncSelect
              {...field}
              {...props}
              defaultOptions={options}
              loadOptions={loadOptions}
              onChange={e => {
                field.onChange(e);
                onChange?.(e);
              }}
              onBlur={field.onBlur}
              placeholder={placeholder || 'Chọn'}
              chakraStyles={{
                menu: (provided, state) => ({
                  ...provided,
                  zIndex: 10,
                }),
              }}
              onMenuScrollToBottom={handleOnScrollBottom}
            />
            <FormErrorMessage>{error && error?.message}</FormErrorMessage>
          </Box>
        </FormControl>
      )}
    />
  );
};

export default AsyncSelectController;
